export default __webpack_public_path__ + "static/media/858_4.6386c23d.jpg";